'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browser = require('@sentry/browser');

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Package Import
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/*
 * Local Import
 */

/*
 * Component
 */
var Logger = function (_React$Component) {
  _inherits(Logger, _React$Component);

  function Logger() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Logger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Logger.__proto__ || Object.getPrototypeOf(Logger)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hasError: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /*
   * PropTypes
   */


  /*
   * State
   */


  _createClass(Logger, [{
    key: 'componentDidMount',


    /*
     * LifeCycles
     */
    value: function componentDidMount() {
      Sentry.init(_extends({
        dsn: this.props.dsn
      }, this.props.options));
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      var _this2 = this;

      // Catch errors in any components below and re-render with error message
      this.setState({ hasError: true }, function () {
        Sentry.withScope(function (scope) {
          Object.keys(info).forEach(function (key) {
            scope.setExtra(key, info[key]);
          });

          if (_this2.props.user) {
            scope.setUser(_this2.props.user);
          }

          Sentry.captureException(error);
        });
      });
    }

    /*
     * Render
     */

  }, {
    key: 'render',
    value: function render() {
      return this.state.hasError ? this.props.renderError : this.props.children;
    }
  }]);

  return Logger;
}(_react2.default.Component);

Logger.propTypes = {
  children: _propTypes2.default.any.isRequired,

  // Logger Config
  dsn: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.object,
  user: _propTypes2.default.object,

  // Text Error Boundary
  renderError: _propTypes2.default.node
};
Logger.defaultProps = {
  options: {},
  user: {},
  renderError: null
};
exports.default = Logger;